import React, { useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";

const GoToTchatBtn = (chatAnchor) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleBtnPosition= ()=>{
    const ieAndFFoxScroll = document.body.scrollTop;
    const gChromeScroll = document.documentElement.scrollTop;

    //const tchatPosition = chatAnchor.chatAnchor.current.offsetTop;
   // console.log("tchatPosition -> tchatPosition", tchatPosition);
    
   // console.log("scroll du chat", tchatPosition);
   // console.log("gChromeScroll", gChromeScroll);
    // if (gChromeScroll + 150 > tchatPosition) {
    //   setIsVisible(false);
    // } else {
    //   setIsVisible(true);
    // }
  }

  useEffect(()=>{

    window.onscroll = function () {
      if(chatAnchor){

        handleBtnPosition()
      }
    };
  },[])
    
  

  const goToTchat = () => {
    chatAnchor.chatAnchor.current.scrollIntoView({ behaviour: "smooth" });
  };

  return (
    <div
      onClick={goToTchat}
      className="goToTchatBtn"
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        opacity: "0.8",
      }}
    >
      {isVisible && (
        <Fab color="secondary" aria-label="edit">
          <ForumTwoToneIcon />
        </Fab>
      )}
    </div>
  );
};

export default GoToTchatBtn;
